/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_To_YamlInputs */

const en_sidebar_to_yaml = /** @type {(inputs: Sidebar_To_YamlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON → YAML`)
};

const ko_sidebar_to_yaml = /** @type {(inputs: Sidebar_To_YamlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON → YAML`)
};

const ja_sidebar_to_yaml = /** @type {(inputs: Sidebar_To_YamlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON → YAML`)
};

/**
* | output |
* | --- |
* | "JSON → YAML" |
*
* @param {Sidebar_To_YamlInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sidebar_to_yaml = /** @type {((inputs?: Sidebar_To_YamlInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_To_YamlInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_to_yaml(inputs)
	if (locale === "ko") return ko_sidebar_to_yaml(inputs)
	return ja_sidebar_to_yaml(inputs)
});